import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {IconWrapper, Inner} from 'components/ui-kit/Button/styled';
import {ExternalLink} from 'components/ui-kit/ExternalLink';
import {breakpoint, colors, border} from 'theme';

export const Container = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    min-width: 0;
    max-width: 100%;
`;

export const SectionTitle = styled.h3`
    margin: 0;
    color: ${colors.darkGrey};
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.32px;
    text-transform: uppercase;
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
    width: 100%;
    min-width: 0;

    @media (min-width: ${breakpoint.tablet}) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const Card = styled.article`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    background: ${colors.white};
    border: 1px solid ${colors.border};
    border-radius: ${border.radius};
`;

export const CardAccent = styled.div`
    flex: none;
    width: 100%;
    height: 3px;
    background: ${colors.red};
`;

export const CardBody = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    min-width: 0;
    padding: 16px 20px;
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    min-width: 0;
`;

export const CardHeaderInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
`;

export const CardTitle = styled.h4`
    margin: 0;
    color: ${colors.darkGrey};
    font-size: 15px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0.22px;
    text-transform: uppercase;
`;

export const StatusBadge = styled.span`
    display: inline-flex;
    flex: none;
    align-items: center;
    gap: 4px;
    padding: 3px 8px;
    border-radius: 999px;
    background: ${colors.dangerSecondary};
    color: ${colors.red};
    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    white-space: nowrap;
`;

export const StatusDot = styled.span`
    flex: none;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: ${colors.red};
`;

export const UnblockButton = styled(Button)`
    width: auto;
    height: auto;
    flex: none;
    font-size: 13px;
    line-height: 20px;

    ${Inner} {
        padding: 7px 14px;
        gap: 6px;
    }

    ${IconWrapper} {
        display: flex;
        flex: none;
        align-items: center;
        justify-content: center;
        width: 14px;
        height: 14px;
        margin-right: 0;

        svg {
            display: block;
            width: 14px;
            height: 14px;
            fill: none;
            stroke: currentColor;
        }
    }
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    background: ${colors.background};
`;

export const DataList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    min-width: 0;
`;

export const DataRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    min-width: 0;
`;

export const DataLabel = styled.span`
    flex: 0 1 auto;
    max-width: 45%;
    color: ${colors.textSecondary};
    font-size: 14px;
    line-height: 20px;
`;

export const DataValue = styled.span<{$danger?: boolean}>`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    flex: 1 1 0;
    min-width: 0;
    color: ${({$danger}) => ($danger ? colors.red : colors.darkGrey)};
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    overflow-wrap: anywhere;
    word-break: break-word;

    > span {
        margin-right: 8px;
        flex: 1 1 0;
        min-width: 0;
        overflow-wrap: anywhere;
        word-break: break-word;
        color: ${colors.brandPrimary};
    }
`;

export const DocumentLink = styled(ExternalLink)`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: ${colors.brandPrimary};
    font-size: 13px;
    font-weight: 600;
    line-height: 19.5px;
    white-space: nowrap;
    text-decoration: none;

    svg {
        display: block;
        flex: none;
        width: 10px;
        height: 10px;
        fill: none;
        stroke: currentColor;
    }
`;

export const SpinnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 180px;
`;
